:host {
  /** @prop --form-group-padding: Set the padding of the <anchor-form-group> */
  --form-group-padding: var(--p-size-static-100) var(--p-size-static-050);
  /** @prop --padding: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding: var(--form-group-padding);
  /** @prop --form-group-flex-derection: Set the flex direction of the <anchor-form-group> */
  --form-group-flex-direction: column;
  /** @prop --flex-direction: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --flex-direction: var(--form-group-flex-direction);
  /** @prop --form-group-flex-gap: Set the flex gap of the <anchor-form-group> */
  --form-group-flex-gap: 0;
  /** @prop --flex-gap: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --flex-gap: var(--form-group-flex-gap);

  display: block;

  ::slotted([slot|='error']) {
    display: block;
    margin-top: var(--p-size-static-100);
    color: var(--color-system-alert-error-contrast);
  }
  ::slotted([slot|='label']) {
    display: block;
    margin-bottom: var(--p-size-static-100);
  }
}

.anchor-c-formgroup {
  display: flex;
  flex-direction: var(--form-group-flex-direction);
  gap: var(--form-group-flex-gap);
  padding: var(--form-group-padding);
}

.error {
  outline: var(--p-size-static-025) solid var(--b-color-error-default);
}

.background {
  --form-group-flex-gap: var(--p-size-static-100);
  --form-group-padding: var(--p-size-static-100) 0;
}
